import { render, staticRenderFns } from "./VoipFlow.vue?vue&type=template&id=46e5c95c&scoped=true&"
import script from "./VoipFlow.vue?vue&type=script&lang=js&"
export * from "./VoipFlow.vue?vue&type=script&lang=js&"
import style0 from "./VoipFlow.vue?vue&type=style&index=0&id=46e5c95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e5c95c",
  null
  
)

export default component.exports